import { EafSummary } from "@/pages/shift-report/models/ShiftReportModels";
import { useTablesStyles } from "@/pages/shift-report/styles/useTablesStyles";
import { Box, Paper } from "@material-ui/core";
import { GridApi, GridReadyEvent, themeMaterial } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { useTableData } from "./hooks/useTableData";

interface Props {
	rows: EafSummary[];
	isLoading: boolean;
}

export const EAFSummaryTable = ({ rows, isLoading }: Props) => {
	const classes = useTablesStyles();
	const { columns, rowData } = useTableData(rows);

	const [gridAPI, setGridAPI] = useState<GridApi | null>(null);

	const onGridReady = (params: GridReadyEvent) => {
		setGridAPI(params.api);
	};
	useEffect(() => {
		if (gridAPI) {
			if (isLoading) gridAPI.showLoadingOverlay();
			else gridAPI.hideOverlay();
		}
	}, [gridAPI, isLoading]);

	return (
		<Paper elevation={0}>
			<Box className={` ${classes.readonlyAgGridBox} ${classes.dynamicHeight}`}>
				<AgGridReact
					rowSelection="single"
					suppressRowClickSelection={true}
					pagination={false}
					singleClickEdit={false}
					tooltipShowDelay={0}
					tooltipHideDelay={2000}
					rowData={rowData}
					columnDefs={columns}
					domLayout="autoHeight"
					onGridReady={onGridReady}
					loading={isLoading}
				/>
			</Box>
		</Paper>
	);
};
